import * as z from 'zod';
import { isArray, isObject, some, isString, keys } from 'lodash';
import debug from 'debug';
const log = debug('itp:runtime:scripting');
export const SCRIPT_SCHEMA = () => z.string().regex(/^{{([\S\s]+)}}$/gm, 'Invalid script expression.');
export const hasNestedScriptExpression = (value) => {
    if (isArray(value)) {
        return some(value, hasNestedScriptExpression);
    }
    if (isObject(value)) {
        return some(value, hasNestedScriptExpression);
    }
    return isScript(value);
};
export const isScript = (value) => isString(value) && /^\s*{{([\S\s]+)}}\s*$/g.test(value.trim());
export const validateScript = (value) => {
    try {
        return;
    }
    catch (err) {
        return err;
    }
};
export const getScriptBody = (value) => {
    const m = /^\s*{{([\S\s]+)}}\s*$/g.exec(value);
    if (!m) {
        throw new Error(`Not a valid script: ${value}`);
    }
    return m[1].trim();
};
const makeFuncBody = (script, ...variables) => {
    const vars = variables.map(k => `${k} = this.${k}`).join(',');
    const s = escape(script);
    const const_definitions = vars.length ? `const ${vars};` : '';
    return `"use strict";
    ${const_definitions}
    try {
      return (${script})
    }
    catch (err) {
      console.error('Error expression:', decodeURIComponent("${s}"));
      console.error('Error scope:', this);
      throw(err);
    }`;
};
function Func(script, ...variables) {
    try {
        const body = makeFuncBody(script, ...variables);
        log('body: %s', body);
        return Function(body);
    }
    catch (err) {
        console.error(script);
        throw err;
    }
}
const makeComplexFunctionBody = (script, ...variables) => {
    const vars = variables.map(k => `${k} = this.${k}`).join(',');
    const s = escape(script);
    const const_definitions = vars.length ? `const ${vars};` : '';
    return `"use strict";
    ${const_definitions}
    try {
      ${script}
    }
    catch (err) {
      console.error('Error expression:', decodeURIComponent("${s}"));
      console.error('Error scope:', this);
      throw(err);
    }`;
};
function ComplexFunc(script, ...variables) {
    try {
        const body = makeComplexFunctionBody(script, ...variables);
        return Function(body);
    }
    catch (err) {
        console.error(script);
        throw err;
    }
}
export function makeFunc(script, scopeVars) {
    if (!isScript(script)) {
        throw new TypeError(`Not a valid Function definition: ${script}`);
    }
    const fn = Func(getScriptBody(script), 'it', ...keys(scopeVars));
    return function (scope) {
        try {
            return fn.call({ ...scopeVars, it: scope });
        }
        catch (err) {
            console.error(err);
            throw err;
        }
    };
}
function makeComplexFunction(script, scopeVars) {
    const body = isScript(script) ? getScriptBody(script) : script;
    const fn = ComplexFunc(body, 'it', ...keys(scopeVars));
    return function (scope) {
        try {
            return fn.call({ ...scopeVars, it: scope });
        }
        catch (err) {
            console.error(err);
            throw err;
        }
    };
}
function getComputedValues(component, ...skip) {
    const result = {};
    return result;
}
//# sourceMappingURL=scripting.js.map